import React, { useEffect, useState } from "react";
import { Button } from "antd";
import SisLoader from "../../../../../widgets/loader";
import { SuccessToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import BwtsTable from "../../components/CargoCraneCom/BwtsRow";
import AddBWTSModal from "../../components/CargoCraneCom/AddBWTSModal";

function Bwts({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  // List BWTS API
  const listBwtsData = () => {
    const formData = new FormData();
    formData.append("ship_id", id);
    try {
      post(ApiURL.list_bwts_details, formData).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.response_data || []);
        }
      });
    } catch (error) {
      console.error("Error fetching BWTS list:", error);
    }
  };

  useEffect(() => {
    listBwtsData();
  }, []);

  // Add BWTS API
  const addBwtsData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("BWT_name", data?.BWT_name);
      formData.append("BWT_maker", data?.BWT_maker);
      formData.append("BWT_model", data?.BWT_model);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append(
        "selected_parameters",
        JSON.stringify(data?.selectedParams)
      );
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.add_bwts_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast(
            "BWTS Details Saved!",
            "BWTS Details Successfully Added!"
          );
          listBwtsData();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while adding BWTS details:", error);
      set_loader(false);
    }
  };

  // Update BWTS API
  const updateBwtsData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("id", data?.id);
      formData.append("ship_id", id);
      formData.append("BWT_name", data?.BWT_name);
      formData.append("BWT_maker", data?.BWT_maker);
      formData.append("BWT_model", data?.BWT_model);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append(
        "selected_parameters",
        JSON.stringify(data?.selectedParams)
      );
      formData.append("other_parameters", JSON.stringify(data?.customParams));

      post(ApiURL.update_bwts_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast(
            "Success",
            res?.message || "BWTS Details Updated Successfully!"
          );
          setIsModalOpen(false);
          listBwtsData();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while updating BWTS details:", error);
      set_loader(false);
    }
  };

  // View BWTS API
  const viewBwtsData = (row) => {
    const formData = new FormData();
    formData.append("ship_id", id);
    formData.append("id", row?.id);
    formData.append("request_type", "view");
    try {
      post(ApiURL.view_bwts_details, formData).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.cargo_machinery_data || {});
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      console.error("Error viewing BWTS details:", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>
          BWTS Information
        </h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add BWTS
        </Button>

        <AddBWTSModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responseData?.id) {
              updateBwtsData({ ...data, id: responseData.id });
            } else {
              addBwtsData(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponseData({});
            set_errors({});
          }}
          responseData={responseData}
          errors={errors}
        />

        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <BwtsTable data={filteredData} onEdit={viewBwtsData} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Bwts;
